import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import {
  RealMoneyBalancePlayerListItemModel,
  RealMoneyBalancePlayerListRequestModel,
  RealMoneyBalancePlayerListResponseModel,
} from '@/models/mga-real-money-balance/mga-real-money-balance.model';
import { clearObj, formatDatesInPayload } from '@marfa/bo-utils';
import { ReportListFilterFields } from '@/models/report/report-list-filter.model';

export class GetRealMoneyBalancePlayerListRequest extends ApiResourceMethod<RealMoneyBalancePlayerListResponseModel> {
  public perform(
    payload: RealMoneyBalancePlayerListRequestModel,
  ): Promise<RealMoneyBalancePlayerListResponseModel> {
    const requestData: RealMoneyBalancePlayerListRequestModel = formatDatesInPayload({
      payload: { ...payload },
      isUnixToString: false,
      isIncludeTime: true,
    }, [
      ReportListFilterFields.DATE_FROM,
      ReportListFilterFields.DATE_TO,
      ReportListFilterFields.EXCHANGE_RATE_DATE,
    ]);

    return this.performer.requestWithMapper(
      { params: clearObj(requestData) },
      (payload: BaseResponse<RealMoneyBalancePlayerListItemModel[]>): RealMoneyBalancePlayerListResponseModel => ({
        data: payload.data,
        headers: payload.headers,
      }),
    );
  }
}
